/** @format */

// This is code generated automatically by the proto2api, please do not modify

export interface CheckInInfo {
  // 入住日期
  startDate: string;
  // 退房日期
  endDate: string;
  // 住了几天 @uint32
  stays: number;
  // 入住时间 @int32
  checkInTime: number;
  // 退房时间 @int32
  checkOutTime: number;
  // 在线checkIn状态
  checkInKind: CheckInKind;
  // 自主入住背景图id
  bannerImgId: string;
  room: Room;
  // 房客信息
  guests: Guest[];
  // 最近更新时间 取订单更新时间和房客更新时间最大值 @uint64
  lastUpdatedAt: string;
}

export interface Room {
  // 房间名字
  name: string;
  // 房间首图
  coverImgId: string;
  // 地址
  address: string;
  // 分组名称
  groupName: string;
  // 面积 @uint32
  roomSize: number;
  // 单人床 @uint32
  singleBedCount: number;
  // 双人床 @uint32
  doubleBedCount: number;
  // 可住人数 @uint32
  personCapacity: number;
  // 房间介绍 '' 就隐藏框框
  introduction: string;
  // 入住方式
  checkInGuide: string;
  // 是否显示入住方式内容 false 才显示card @bool
  hideCheckInGuideCard: boolean;
  // 是否显示入住方式内容 false 才显示内容 (校验checkInKind = 0 未填写房客，校验checkInKind != 0 已填写 ) @bool
  hideCheckInGuideText: boolean;
}

export interface Guest {
  // 房客id
  id: string;
  // 姓
  familyName: string;
  // 名
  givenName: string;
  // 性别
  sex: Sex;
  // 生日
  birthday: string;
  // 职业
  profession: string;
  // 国籍
  nationality: string;
  // 国家/地区
  residenceCountry: string;
  // 国家/地区数据 目前仅中国大陆和日本会有值
  geoData: GeoData;
  // 居住详细地址 [省,市,区县,街道地址,居住地址,门牌号]
  addresses: string[];
  // 入住前住处
  preStayAddress: string;
  // 离店后住处
  postStayAddress: string;
  // 邮编
  postcode: string;
  // 手机号
  tel: Tel;
  // 邮箱
  email: string;
  // 证件
  document: Document;
  // 证件图片id
  documentImgId: string;
}

export interface GeoData {
  // 地区代码 ids 和 names 长度，必须一致
  ids: string[];
  // 地区代码名称
  names: string[];
}

export interface Tel {
  // 手机区号
  kind: string;
  // 手机号
  number: string;
}

export interface Document {
  // 证件类型
  kind: string;
  // 证件号码
  number: string;
}
export enum Sex {
  Unknown = 0,
  // 男
  Male = 1,
  // 女
  Female = 2,
}
export enum CheckInKind {
  // 默认
  CheckInOn = 0,
  // 停止
  CheckInOff = -1,
  // 结束
  CheckInDone = 1,
}
